module.exports = __webpack_public_path__ + "static/media/mask.eb3f1221.jpeg";